<div class="container">
  <div class="loader" *ngIf="loading"></div>

  <div *ngIf="mode == 'EDIT' && !loading" class="animate__animated animate__fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top shadow-sm">
      <div class="container-fluid">
        <span class="navbar-text">
          Solicitud de Compra
        </span>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" (click)="cancelEvent()">
            Cerrar
          </button>
          <button class="btn btn-primary" (click)="saveEvent()">
            Guardar
          </button>
        </div>
      </div>
    </nav>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label" for="consecutive">Consecutivo</label>
        <input type="text" class="form-control" id="consecutive" name="consecutive" [ngModel]="model.consecutive" disabled>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label" for="initialDecisionCode">Código de Decisión Inicial</label>
        <input type="text" class="form-control" id="initialDecisionCode" name="initialDecisionCode" [(ngModel)]="model.initialDecisionCode">
        <div *ngIf="formErrors.get('purchaserequest.initialDecisionCode')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaserequest.initialDecisionCode') }}
        </div>
      </div>
      <div class="col-md-6">
        <label class="form-label" for="initialDecisionDate">Fecha de Decisión Inicial</label>
        <mt-date-picker [(date)]="model.initialDecisionDate" name="initialDecisionDate" id="initialDecisionDate" label="Fecha de Decisión Inicial"/>
        <div *ngIf="formErrors.get('purchaserequest.initialDecisionDate')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaserequest.initialDecisionDate') }}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <label class="form-label" for="description">Descripción</label>
        <textarea class="form-control" id="description" name="description" [(ngModel)]="model.description" rows="3"></textarea>
        <div *ngIf="formErrors.get('purchaserequest.description')" class="badge bg-danger animated fadeIn">
          {{ formErrors.get('purchaserequest.description') }}
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Líneas de Solicitud</span>
        <button class="btn btn-sm btn-outline-primary" (click)="addLine()">
          <i class="fa fa-plus"></i> Agregar Línea
        </button>
      </div>
      <div class="card-body">
        <div *ngFor="let line of model.lines; let i = index" class="row mb-2 align-items-end">
          <div class="col-md-5">
            <label class="form-label" *ngIf="i === 0">Monto a Comprometer</label>
            <input type="number" class="form-control" [(ngModel)]="line.amountToCommit" (change)="calculateTotal()" name="amountToCommit_{{i}}">
            <div *ngIf="formErrors.get('purchaserequest.lines[' + i + '].amountToCommit')" class="badge bg-danger animated fadeIn">
              {{ formErrors.get('purchaserequest.lines[' + i + '].amountToCommit') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label" *ngIf="i === 0">Cuenta</label>
            <ng-select class="custom"
                       [(ngModel)]="line.account" [appendTo]="'body'" title="Cuenta" name="account_{{i}}">
              <ng-option *ngFor="let account of budgetAccounts" [value]="account.id">{{account.code}} - {{account.description}}</ng-option>
            </ng-select>
            <div *ngIf="formErrors.get('purchaserequest.lines[' + i + '].account')" class="badge bg-danger animated fadeIn">
              {{ formErrors.get('purchaserequest.lines[' + i + '].account') }}
            </div>
          </div>
          <div class="col-md-1">
            <button class="btn btn-outline-danger" (click)="removeLine(i)" [disabled]="model.lines.length <= 1">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-5 offset-md-7 text-end">
            <strong>Total: {{model.totalAmountToCommit | currency:'CRC'}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="mode == 'LIST' && !loading" class="animate__animated animate__fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top shadow-sm">
      <div class="container-fluid">
        <form class="d-flex">
          <div class="flex-grow-1 me-2">
            <input type="text" class="form-control" [(ngModel)]="searchText" name="searchText"
                   placeholder="Buscar..." (change)="searchEvent()"/>
          </div>
        </form>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" (click)="refreshEvent()" title="Refrescar">
            <span class="fa fa-sync fa-lg"></span>
          </button>
          <button class="btn btn-primary" (click)="createEvent()" title="Agregar">
            Agregar
          </button>
        </div>
      </div>
    </nav>

    <mt-pagination (loadPage)="getPageEvent($event)" [page]="page"></mt-pagination>

    <table *ngIf="page.metadata.pages > 0" class="table table-hover">
      <thead>
      <tr>
        <th>Consecutivo</th>
        <th>Código de Decisión</th>
        <th>Fecha</th>
        <th>Monto Total</th>
        <th class="mt-actions-col"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pr of page.content">
        <td (click)="editEvent(pr)" class="mt-content-col">
          {{pr.consecutive}}
        </td>
        <td (click)="editEvent(pr)" class="mt-content-col">
          {{pr.initialDecisionCode}}
        </td>
        <td (click)="editEvent(pr)" class="mt-content-col">
          {{pr.initialDecisionDate}}
        </td>
        <td (click)="editEvent(pr)" class="mt-content-col">
          {{pr.totalAmountToCommit | currency:'CRC'}}
        </td>
        <td class="mt-actions-col">
          <button class="btn btn-link btn-lg pull-right" (click)="downloadDocument(pr.id)" title="Descargar">
            <span class="fa fa-download fa-lg"></span>
          </button>
          <button class="btn btn-link btn-lg pull-right" data-bs-toggle="modal" data-bs-target="#removePRConfirmation"
                  (click)="selectEvent(pr)" title="Borrar">
            <span class="fa fa-trash-alt fa-lg"></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div *ngIf="page.metadata.pages == 0">
      No hay registros
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="removePRConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el registro?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeEvent(model)">Borrar</button>
        </div>
      </div>
    </div>
  </div>
</div>
